
"use strict";

class Viewer {

	constructor() {

		this.camera = null;
		this.scene = null;
		this.renderer = null
		this.stereoEffect = null;
		this.deviceOrientationControls = null;
		this.mainMesh = null;
		this.rightEyeMesh = null;
		this.spinner = null;
		this.clock = null;

	 	this.defaultFov = 75.0;
	 	this.minFov = 45.0;
	 	this.maxFov = 90.0;

		this.isMobile = false;
		this.allowZoom = false;
	 	this.isStereoMode = false;
	 	this.isLoading = false;
	 	this.isFullScreen = false;
	 	this.initialLoad = true;
		this.manualCameraControl = false;
	 	this.debug = false;

		this.isUserInteracting = false;
		this.onMouseDownMouseX = 0;
		this.onMouseDownMouseY = 0;
		this.lon = 0; 
		this.onMouseDownLon = 0; 
		this.lat = 0;
		this.onMouseDownLat = 0; 
		this.phi = 0;
		this.theta = 0;

		this.DisplayMode = Object.freeze({"normal":1, "stereo":2 });
		this.FadeDirection = Object.freeze({"in":1, "out":2});
		this.poiVisibilityState = new POIVisibilityState();
		this.overview = null;
		this.portalController = null;

	}

	onWebFontsLoaded() {

		this.init();
		this.animate();
	}

	onWebFontsLoadFailed() {
		// TODO: init anyway using fallback fonts

		if(this.debug) {
			console.log("Error: Unable to load webfonts");
		}
	}

	init() {

		this.clock = new THREE.Clock();

		this.isMobile = AppTools.isMobileDevice();

		if(!this.isMobile) {
			this.overview = new Overview();
		}

		var container;

		container = document.getElementById( 'container' );

		this.camera = new THREE.PerspectiveCamera( this.defaultFov, window.innerWidth / window.innerHeight, 1, 1100 );
		this.camera.rotation.order = "YZX";
		//camera = new THREE.PerspectiveCamera(90, window.innerWidth / window.innerHeight, 0.001, 700);
		this.camera.target = new THREE.Vector3( 0, 0, 0 );

		this.scene = new THREE.Scene();
		this.scene.add(this.camera);

		var mainGeometry = new THREE.SphereGeometry( 500, 60, 40 );
		mainGeometry.scale( - 1, 1, 1 );

		var mainMaterial = new THREE.MeshBasicMaterial();
		this.mainMesh = new THREE.Mesh( mainGeometry, mainMaterial );
		this.scene.add(this.mainMesh);
		this.mainMesh.visible = false;
		TweenHelpers.trackOriginalOpacities(this.mainMesh);

		// only enable stereo mode on mobile
		if(this.isMobile) {
			// create the geometry used for the right eye
			var rightEyeGeometry = new THREE.SphereGeometry( 500, 60, 40 );
			rightEyeGeometry.scale( - 1, 1, 1 );

			var rightEyeMaterial = new THREE.MeshBasicMaterial();

			this.rightEyeMesh = new THREE.Mesh(rightEyeGeometry, rightEyeMaterial);
			this.scene.add(this.rightEyeMesh);
			this.rightEyeMesh.visible = false;
			TweenHelpers.trackOriginalOpacities(this.rightEyeMesh);
		}

		this.renderer = new THREE.WebGLRenderer();
		this.renderer.setPixelRatio( window.devicePixelRatio );
		this.renderer.setSize( window.innerWidth, window.innerHeight );
		container.appendChild( this.renderer.domElement );

		if(!this.isMobile) {

			document.addEventListener('mousedown', e => { this.onDocumentMouseDown(e); }, false);
			document.addEventListener('mousemove', e => { this.onDocumentMouseMove(e); }, false);
			document.addEventListener('mouseup', e => { this.onDocumentMouseUp(e); }, false);
			document.addEventListener('wheel', e => { this.onDocumentMouseWheel(e); }, false);

		} else {

			window.addEventListener('deviceorientation', e => { this.setOrientationControls(e); }, true);
		}

		// prevent pinch-zoom
		document.addEventListener('touchmove', function (event) {
		  if (event.scale !== 1) { event.preventDefault(); }
		}, false);

		window.addEventListener('resize', e => { this.onWindowResize(e); }, false);

		var self = this;

		THREE.DefaultLoadingManager.onLoad = function () {
			self.onThreeJSLoad();
		}

		THREE.DefaultLoadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
			self.onLoadProgress(url, itemsLoaded, itemsTotal);
		}

		if(this.isMobile) {
			this.deviceOrientationControls = new THREE.DeviceOrientationControls(this.camera, true);
			this.deviceOrientationControls.connect();
			this.stereoEffect = new THREE.StereoEffect(this.renderer);
		}

		this.portalController = new PortalController();

		// finally, load the default scene
		this.loadDefaultScene()
	}

	loadDefaultScene() {

		var defaultScene = sceneCollection.getDefaultScene().name;
		var queryParam = AppTools.getUrlParameterByName("scene");

		if(typeof(queryParam)==="string") {
			if(sceneCollection.isValidScene(queryParam)) {
				defaultScene = queryParam;
			}
		}

		this.loadScene(null, defaultScene);
	}


	unloadPreviousScene() {

		this.clearAllSprites();
	}


	fadeScene(fadeDirection) {

		var dir = (fadeDirection===this.FadeDirection.in) ? "in" : "out";
		var opacity = (fadeDirection===this.FadeDirection.in) ? 0.0 : 1.0;
		var duration = 1000.0;

		viewer.mainMesh.material.opacity = opacity;
		TweenHelpers.fadeMesh(viewer.mainMesh, dir, {duration: duration});
	}

	loadScene(event, manualSceneName=null) {

		viewerUI.showLoadingSpinner(true);
		viewer.isLoading = true;

		this.unloadPreviousScene();

		var sceneName = (manualSceneName!=null) ? manualSceneName : event.data.sceneName;
		var sceneData = sceneCollection.getSceneByName(sceneName);

		sceneCollection.setActiveScene(sceneName);

		// load and assign textures to the sphere geometry meshes

		// deallocate the previous map
		if(this.mainMesh.material.map!=null) {
			this.mainMesh.material.map.dispose();
		}

		this.mainMesh.material.map = new THREE.TextureLoader().load(sceneData.leftEyeImage);
		this.mainMesh.material.needsUpdate = true;

		if(this.isMobile) {

			// deallocate the previous map
			if(this.rightEyeMesh.material.map!=null) {
				this.rightEyeMesh.material.map.dispose();
			}

			this.rightEyeMesh.material.map = new THREE.TextureLoader().load(sceneData.rightEyeImage);
			this.rightEyeMesh.material.needsUpdate = true;
		}
		// assign UI labels
		viewerUI.populateSceneInfo(sceneData.headline, sceneData.description);

		// handle UI selection
		if(event != null) {
			viewerUI.selectActiveScene($(event.target));
		}

		// set starting lon/lat
		this.lat = sceneData.startLat;
		this.lon = sceneData.startLon;
	}

	switchRenderMode(displayMode) {

		if(displayMode === this.DisplayMode.stereo) {

			this.isStereoMode = true;
			this.mainMesh.layers.set(1);
			this.rightEyeMesh.layers.set(2);
			viewerUI.showSceneSelection(false);
			viewerUI.showLogo(false);
			viewerUI.showInfo(false);

		} else {

			this.isStereoMode = false;
			this.mainMesh.layers.set(0);
			viewerUI.showSceneSelection(true);
			viewerUI.showLogo(true);
			viewerUI.showInfo(true);
		}

		// update mesh states
		this.updateMeshVisibility();
		// force redraw
		this.onWindowResize();
	}

	onWindowResize(event) {

		this.camera.aspect = window.innerWidth / window.innerHeight;
		this.camera.updateProjectionMatrix();

		this.renderer.setSize( window.innerWidth, window.innerHeight );

		if(!this.isMobile) {
			this.overview.placeOverview();
		}
	}

	onDocumentMouseDown( event ) {

		event.preventDefault();

		this.isUserInteracting = true;

		this.onPointerDownPointerX = event.clientX;
		this.onPointerDownPointerY = event.clientY;

		this.onPointerDownLon = this.lon;
		this.onPointerDownLat = this.lat;
	}

	onDocumentMouseMove( event ) {

		if ( this.isUserInteracting === true ) {

			this.lon = ( this.onPointerDownPointerX - event.clientX ) * 0.1 + this.onPointerDownLon;
			this.lat = ( event.clientY - this.onPointerDownPointerY ) * 0.1 + this.onPointerDownLat;
		}
	}

	onDocumentMouseUp( event ) {

		this.isUserInteracting = false;
	}

	onDocumentMouseWheel( event ) {

		if(!this.allowZoom) {
			return;
		}

		this.setFOV(AppTools.clamp(this.camera.fov += event.deltaY * 0.05, this.minFov, this.maxFov));
	}

	animate() {

		requestAnimationFrame(this.animate.bind(this));
		TWEEN.update();
		this.update();
	}

	setFov(value) {

		this.camera.fov = value;
		this.camera.updateProjectionMatrix();
	}

	setDefaultFov() {

		this.setFov(this.defaultFov);
	}

	setOrientationControls(e) {

		if(!e.alpha) {
			return;
		}
	}

	createPOISprite(cameraPos, intersectionPos, spriteScale, spriteTint, spriteDistPercentage, headerText, subText, visible=true) {

	    // calculate positioning
	    var startPos = cameraPos;
	    var direction = new THREE.Vector3();
	    direction.subVectors(intersectionPos, startPos);

	    var finalPos = new THREE.Vector3();
	    finalPos.addVectors(startPos, direction.multiplyScalar(spriteDistPercentage));

		// insert sprite labels
		var fontSize = 50;
		var headerFontFamily = "SkanskaSansProRegular";
		var subtextFontFamily = "SkanskaSansProBold";

		var canvas = document.createElement('canvas');
		var context = canvas.getContext('2d');
		var innerImageHeight = 256;

		context.canvas.width = 512;
		context.canvas.height = 512;

		context.lineWidth = 2;

		context.font = fontSize + "px " + headerFontFamily;
		var headerMetrics = context.measureText(headerText);
		var headerTextWidth = headerMetrics.width;
		context.fillText(headerText, context.canvas.width*0.5-headerTextWidth*0.5, context.canvas.height*0.5+fontSize);

		context.font = fontSize + "px " + subtextFontFamily;
		var subTextMetrics = context.measureText(subText);
		var subTextWidth = subTextMetrics.width;
		context.fillText(subText, context.canvas.width*0.5-subTextWidth*0.5, context.canvas.height*0.5+fontSize*2.5);

		if(this.debug) {
			context.fillStyle = "rgba(1.0, 0.0, 0.0, 0.5)";
			context.fillRect(0, 0, context.canvas.width, context.canvas.height);
		}

		// canvas contents will be used as a texture
		var texture = new THREE.Texture(canvas) 
		texture.needsUpdate = true;
		
		// create the sprite and position it
		var spriteMaterial = new THREE.SpriteMaterial( { map: texture, color: spriteTint } );
		var sprite = new THREE.Sprite(spriteMaterial);
		sprite.scale.set(spriteScale, spriteScale, spriteScale);
		sprite.position.set(finalPos.x, finalPos.y, finalPos.z);

		// fit the image into the texture size and add the sprite to the scene
		var spriteImage = new Image();
		spriteImage.src = 'textures/poi_sprite_greyscale.png';

		var self = this;
		spriteImage.onload = function(){
			context.drawImage(spriteImage, context.canvas.width*0.5-spriteImage.width*0.5, 0, spriteImage.width, spriteImage.height);
			self.scene.add(sprite);
			sprite.visible = visible;
		}

		return sprite;
	}

	insertPOIDataFromJSON(jsonObject) {

		var dataset = jsonObject.dataset;
		var disabledTags = this.poiVisibilityState.getDisabledTags();
		var visible = true;

		for(var i=0; i<dataset.length; i++) {

			var intersectionPoint = new THREE.Vector3(dataset[i].intersectionPoint.x, dataset[i].intersectionPoint.y, dataset[i].intersectionPoint.z);
			var header = dataset[i].headerText;
			var sub = dataset[i].subText;
			var scale = dataset[i].scale;
			var color = dataset[i].color;
			var distPercentage = dataset[i].distPercentage;
			var categoryTag = dataset[i].categoryTag;

			// if not filtered, mark it as enabled
			if(disabledTags.indexOf(categoryTag.toLowerCase()) === -1) {
				this.poiVisibilityState.setTagState(categoryTag, true);
				visible = true;
			} else {
				visible = false;
			}

			var sprite = this.createPOISprite(this.camera.position, intersectionPoint, scale, color, distPercentage, header, sub, visible);
			this.addPOISpriteMetaData(sprite, intersectionPoint, scale, color, distPercentage, header, sub, categoryTag);
		}
	}

	togglePOIByCategory(categoryTag, visibilityFlag) {

		var categoryFilter = categoryTag.toLowerCase();

		this.scene.traverse (function (object) {

			if (object instanceof THREE.Sprite) {
				if(object.meta != undefined) {
					if(object.meta.categoryTag.toLowerCase()===categoryFilter) {
						object.visible = visibilityFlag;
					}
				}
			} 
		});
	}

	addPOISpriteMetaData(sprite, intersectionPoint, scale, color, distPerc, header, sub, categoryTag) {

		sprite.meta = {};
		sprite.meta.intersectionPoint = intersectionPoint;
		sprite.meta.scale = scale;
		sprite.meta.color = color;
		sprite.meta.distPercentage = distPerc;
		sprite.meta.headerText = header;
		sprite.meta.subText = sub;
		sprite.meta.categoryTag = categoryTag;
	}

	clearAllSprites() {

		var objectsToRemove = [];

		// find the target objects
		this.scene.traverse (function (object) {
			if (object instanceof THREE.Sprite) {
				objectsToRemove.push(object);
			} 
		});

		// remove the targets
		for (var i=0; i<objectsToRemove.length; i++) {
			this.scene.remove(objectsToRemove[i]);
		}
	}

	scalePOISprites(uniformScaleFactor) {

		var sf = uniformScaleFactor;

		this.scene.traverse (function (object) {
			if (object instanceof THREE.Sprite) {
				object.scale.set(object.scale.x * sf, object.scale.y * sf, object.scale.z * sf);
			}
		});
	}

	scalePOISpritesByFov() {
		
		// TODO:
		// current fov
		// fov diff from default as a factor

		this.scene.traverse (function (object) {
			if (object instanceof THREE.Sprite) {
				//object.scale.set(camera.fov * );
			} 
		});	
	}

	updateMeshVisibility() {

		if(this.isMobile) {

			if(this.isStereoMode) {
				this.mainMesh.visible = true;
				this.rightEyeMesh.visible = true;

			} else {
				this.mainMesh.visible = true;
				this.rightEyeMesh.visible = false;
			}

		} else {
			this.mainMesh.visible = true;
		}
	}

	updatePOIData() {

		var activeScene = sceneCollection.getActiveScene();

		if(!this.isMobile && activeScene.poiData != null) {
			this.insertPOIDataFromJSON(activeScene.poiData);
		}
	}

	updatePOIVisibility() {

		var disabledTags = this.poiVisibilityState.getDisabledTags();
		
		for(var i=0; i<disabledTags.length; i++) {
			this.togglePOIByCategory(disabledTags[i], false);
		}
	}


	onThreeJSLoad() {

		viewerUI.showLoadingSpinner(false);

		if(!viewer.isMobile) {
			this.fadeScene(this.FadeDirection.in);
		}

		if(this.initialLoad) {
			viewerUI.populateSceneSelection();
			viewerUI.showMainUI(true);
			viewerUI.selectActiveSceneByName(sceneCollection.getActiveSceneName());

			if(!this.isMobile) {
				viewerUI.showUsageInstructions("#instruction-overlay-desktop");
			} else {
				viewerUI.mobileCSSRules();
				viewerUI.showUsageInstructions("#instruction-overlay-mobile");
			}

			this.initialLoad = false;
		}

		this.updatePOIData();
		this.portalController.updatePortalData();
		this.updateMeshVisibility();
		viewerUI.updateVisibility();

		viewer.isLoading = false;
	}


	onLoadProgress(url, itemsLoaded, itemsTotal) {

		if(this.debug) {
			console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );		
		}
	}


	update() {

		if(this.isMobile) {

			this.deviceOrientationControls.update();

			if(this.isStereoMode) {
				this.stereoEffect.render(this.scene, this.camera);
			} else {
				this.renderer.render(this.scene, this.camera);
			}

		} else {

			if(!this.manualCameraControl) {

				this.lat = Math.max( - 85, Math.min( 85, this.lat ) );
				this.phi = THREE.Math.degToRad( 90 - this.lat );
				this.theta = THREE.Math.degToRad( this.lon );

				this.camera.target.x = 500 * Math.sin( this.phi ) * Math.cos( this.theta );
				this.camera.target.y = 500 * Math.cos( this.phi );
				this.camera.target.z = 500 * Math.sin( this.phi ) * Math.sin( this.theta );

				this.camera.lookAt( this.camera.target );
			}

			this.renderer.render(this.scene, this.camera);
		}

		/*
		// distortion
		camera.position.copy( camera.target ).negate();
		*/
	}

}

var viewer = new Viewer();
var viewerUI = new ViewerUI();
